/**
 * Zero-pad a number to a specified number of places.
 * @param num The number to pad.
 * @param places The total number of places to pad to.
 */
export const zeroPad = (num, places) => String(num).padStart(places, '0');
/** Matches an address of the form `local@domain.tld`; mirrors the editor's own check. */
const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
/**
 * Whether a string looks like an email address. Used to gate submit buttons before the
 * request is sent; the backend remains the authority.
 * @param email The address to check.
 */
export const validateEmail = (email) => EMAIL_PATTERN.test(email);
